/**
 * Is this string a CIS order number (`ORD-K48193`)?
 *
 * The portal's one restatement of `ORDER_NO_PATTERN` (`modules/orders_module/models/order.py`, built by
 * `modules/cis_numbers.py`: the prefix, one or two letters of its 21-letter alphabet, five digits); if the
 * alphabet changes there, it changes here. It exists because two things reach the same `/orders/{x}` address:
 * a Tharstern job's order ref (the old order detail page) and a CIS order's number (the signed-in CIS order
 * page, and the address Stripe returns a card payment to). Only the shape tells them apart, and a Tharstern
 * ref or order number is never of it (Tharstern numbers are plain digits, its order refs `o-...`).
 */
const CIS_ORDER_NO = /^ORD-[ACDEFGHJKLMNPQRTUVWXY]{1,2}[0-9]{5}$/;

export function isCisOrderNo(value: string): boolean {
  return CIS_ORDER_NO.test(value);
}
